import api from "../api";
import backEnd from "../../constants/backEnd";

const postStripeSuccess = async (sessionId) => {
    const response = await api.post(`${backEnd.url}webhooks/stripe/success/`, {
        session_id: sessionId,
    });
    
    return response.data;
};

export default postStripeSuccess;
